import * as breakpoints from "../../breakpoints";
import * as colors from "../../constants/colors";
import * as languages from "../../constants/languages";
import { browserHistory } from "react-router";
import uuidv4 from "uuid/v4";
import { english, spanish } from "../../constants/strings";
import { css, StyleSheet } from "aphrodite";
import { login } from "../../api/auth";
import { me } from "../../api/account";
import { getClass, startClass } from "../../api/class";
import { handleUnknownError } from "../../lib/errorHandler";
import loginStyles from "../../styles/loginStyles";
import Banner from "../Banner";
import ClassDetails from "../ClassDetails";
import AltCourseTile from "../AltCourseTile";
import { Column, Container, Row } from "../../grid";
import Link from "react-router/lib/Link";
import { NotificationManager } from "react-notifications";
import Page from "../Page";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import querystring from "querystring";
import * as util from "../../lib/util";
import typeColors from "../../constants/typeColors";
import { lrsUrl, lrsAuth } from "../../config";
import LiveSession from "../LiveSession";
import * as courseTypes from "../../constants/courseTypes";
import * as courseFormats from "../../constants/courseFormats";
import LiveRegistrationModal from "../LiveRegistrationModal";

const styles = StyleSheet.create({
	accessibilityLinkContainer: {
		marginTop: 20,
	},
	breadcrumbs: {
		maxWidth: 960,
		width: "100%",
		margin: "auto",
		paddingTop: 24,
		paddingRight: 40,
		paddingBottom: 20,
		fontFamily: "priori-sans",
		fontSize: 14,
		display: "flex",
		boxSizing: "border-box",
		[breakpoints.mobileOnly]: {
			paddingLeft: 12,
			paddingTop: 12,
			paddingBottom: 12,
			paddingRight: 12,
		},
	},
	breadcrumbsCategory: {
		fontWeight: "bold",
		color: colors.black5,
	},
	breadcrumbsTitle: {
		color: colors.purple2,
	},
	clickHere: {
		textDecoration: "underline",
	},
	contentContainer: {
		marginTop: 16,
		[breakpoints.mobileOnly]: {
			marginTop: 20,
		},
	},
	courseLink: {
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		fontSize: 15,
		marginBottom: 8,
		color: colors.black4,
		lineHeight: 1.33,
	},
	description: {
		fontSize: 15,
		lineHeight: 1.33,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		marginBottom: 24,
		[breakpoints.mobileOnly]: {
			marginLeft: 14,
			marginRight: 14,
		},
	},
	disclaimer: {
		marginTop: 10,
		fontStyle: "italic",
		fontSize: "12px",
		lineHeight: "16px",
		color: colors.black8,
	},
	formLabel: {
		marginBottom: 10,
		display: "block",
	},
	loginButton: {
		marginBottom: 16,
	},
	loginMessage: {
		marginTop: 20,
		marginBottom: 20,
		fontSize: 15,
		color: colors.black4,
	},
	sectionTitleBanner: {
		paddingTop: 26,
		paddingBottom: 26,
		width: "100vw",
		backgroundColor: colors.pink,
		color: colors.black3,
		fontSize: 30,
		fontFamily: "priori-sans",
		marginTop: 38,
	},
	sectionTitle: {
		maxWidth: 960,
		width: "100%",
		margin: "auto",
		boxSizing: "border-box",
		paddingLeft: 12,
	},
	sectionContentContainer: {
		position: "relative",
	},
	input: {
		width: "95%",
		maxWidth: 460,
		height: 40,
		fontSize: 15,
		fontFamily:
			"TrebuchetMS, Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, Tahoma,sans-serif",
		border: `1px solid ${colors.gray2}`,
	},
	mainButton: {
		border: `3px solid ${colors.darkTeal2}`,
		borderRadius: 25.5,
		backgroundColor: colors.lightTeal,
		fontSize: 16,
		color: colors.darkGreen,
		lineHeight: 1.06,
		fontWeight: "bold",
		fontFamily: "priori-sans",
		paddingTop: 20,
		paddingBottom: 20,

		width: 200,
		marginTop: 20,
	},
	startButton: {
		[breakpoints.tabletAndUp]: {
			marginTop: 40,
		},
	},
	startButtonContainer: {
		display: "flex",
		flexDirection: "column",
		[breakpoints.mobileOnly]: {
			alignItems: "center",
		},
	},
	scheduleContainer: {
		marginTop: 20,
		fontFamily: "priori-sans",
		fontWeight: "bold",
		fontSize: 24,
		lineHeight: 1.2,
		color: colors.black4,
		[breakpoints.mobileOnly]: {
			marginBottom: 40,
		},
		width: "100%",
		border: `1px dashed ${colors.gray2}`,
		borderCollapse: "collapse",
	},
	typeContainer: {
		fontSize: 18,
		lineHeight: 1.39,
		paddingTop: 20,
		paddingLeft: 18,
		paddingRight: 18,
		paddingBottom: 20,
		fontFamily: "freight-sans-pro",
		marginBottom: 24,
		backgroundColor: colors.gray3,
		[breakpoints.mobileOnly]: {
			marginLeft: -10,
			marginRight: -10,
		},
	},
	typeTitle: {
		display: "inline",
		fontFamily: "freight-sans-pro",
		fontWeight: "bold",
		fontSize: 15,
		letterSpacing: 0.21,
		color: colors.black,
		paddingLeft: 5,
		paddingRight: 5,
	},
	typeDescriptionContainer: {
		marginTop: 13,
		display: "inline",
	},
	altClassContainer: {
		backgroundColor: colors.white,
		minHeight: 400,
		paddingTop: 20,
	},
	avatar: {
		height: 100,
		width: 100,
		backgroundColor: colors.lightGreen,
		borderRadius: "50%",
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		backgroundSize: "cover",
		backgroundPosition: "50% 50%",
		backgroundRepeat: "no-repeat",
	},
	avatarText: {
		fontFamily: "freight-sans-pro",
		fontWeight: "normal",
		color: colors.white,
	},
	host: {
		display: "flex",
		textAlign: "center",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
	hostRow: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-around",
		marginTop: 20,
	},
	hostText: {
		fontFamily: "freight-sans-pro",
		fontWeight: "normal",
		marginTop: 0,
		marginBottom: 0,
	},
});

export default class ClassPage extends PureComponent {
	static propTypes = {
		params: PropTypes.object.isRequired,
		language: PropTypes.string.isRequired,
		pathname: PropTypes.string.isRequired,
		loggedIn: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;

		this.state = {
			course: {},
			loginEmail: "",
			error: null,
			email: null,
			meRequestReturned: false,
			classFullCount: 0,
			showModal: false,
			selectedSession: {},
		};
	}

	componentDidMount() {
		this._loadClass(this.props.params.class_id);
		this._getMe();
	}

	_getMe = () => {
		me()
			.then(data => {
				this.setState({
					email: data.email,
					meRequestReturned: true,
				});
			})
			.catch(() => {
				console.log("failed to get user data");
				this.setState({
					meRequestReturned: true,
				});
			});
	};

	_loadClass = classId => {
		getClass(classId, this.props.language === languages.es ? languages.es : null)
			.then(data => {
				this.setState({
					course: data,
				});
				if (data.type === courseTypes.live) {
					let fullClasses = 0;
					data.classSchedule.forEach(session => {
						if (session.registrationFull) {
							fullClasses += 1;
						}
					});
					this.setState({ classFullCount: fullClasses });
				}
			})
			.catch(err => {
				handleUnknownError(err);
				NotificationManager.error(this.strings.errors.failedToLoadClass);
				if (err.response && err.response.status === 404) {
					browserHistory.push({
						pathname: "/class",
						query: { language: this.props.language },
					});
				}
			});
	};

	_login = e => {
		e.preventDefault();
		login(this.state.loginEmail)
			.then(() => {
				window.location.reload();
			})
			.catch(err => {
				if (err.response && err.response.status === 400) {
					this.setState({
						error: this.strings.errors.accountNotFound,
					});
				} else {
					this.setState({
						error: this.strings.errors.loginFailed,
					});
				}
			});
	};

	_startClass = () => {
		if (this.state.meRequestReturned) {
			startClass(
				this.props.params.class_id,
				this.props.language === languages.es ? languages.es : null,
				null,
			)
				.then(() => {
					let params = {};
					if (this.state.course.format === courseFormats.captivate) {
						params = {
							email: this.state.email ? this.state.email : "",
							language: this.props.language ? this.props.language : "",
							activity_id: `http://${util.slugify(
								this.state.course.name.toLowerCase(),
							)}`,
						};
					} else {
						params = {
							slide: 1,
							email: this.state.email ? this.state.email : "",
							auth: lrsAuth,
							endpoint: lrsUrl,
							actor: JSON.stringify({
								objectType: "Agent",
								mbox: `mailto:${this.state.email ? this.state.email : "test@texaswic.org"
									}`,
							}),
							activity_id: `http://${util.slugify(
								this.state.course.name.toLowerCase(),
							)}`,
						};
					}
					const qs = querystring.stringify(params);

					window.location.assign(`${this.state.course.captivate.url}?${qs}`);
				})
				.catch(err => {
					if (err.response && err.response.status === 401) {
						// NOTE: This is a stop-gap solution. Need to build real refresh interceptor
						util.deleteCookies();
						window.location.assign("/login");
					}
				});
		}
	};

	_startRecordedClass = () => {
		const qs = querystring.stringify({
			email: this.state.email ? this.state.email : "",
			language: this.props.language ? this.props.language : "",
		});
		window.location.assign(`${this.state.course.recordedRegistrationURL}?${qs}`);
	};

	_setLoginEmail = email => {
		this.setState({
			loginEmail: email,
		});
	};

	_learningOutcomes = () => {
		return this.state.course.learningOutcomes
			? this.state.course.learningOutcomes.split("\n").filter(str => str.trim().length > 0)
			: [];
	};

	_loggedOutContent = () => {
		let qs = querystring.stringify({
			email: this.state.email,
			language: this.props.language,
		});

		const accessibleLink = `/class/${this.props.params.class_id}/accessible?${qs}`;

		const anonymousEmail = `${uuidv4()}@texaswic.org`;

		qs = querystring.stringify({
			slide: 1,
			email: this.state.email,
			language: this.props.language ? this.props.language : "",
			endpoint: lrsUrl,
			auth: lrsAuth,
			actor: JSON.stringify({
				objectType: "Agent",
				mbox: `mailto:${this.state.email ? this.state.email : anonymousEmail}`,
			}),
			activity_id: `http://${util.slugify(this.state.course.name.toLowerCase())}`,
		});
		const anonymousLink = this.state.course.captivate
			? `${this.state.course.captivate.url}?${qs}`
			: "";

		return (
			<div className={css(styles.sectionContentContainer)}>
				<div className={css(styles.sectionTitleBanner)}>
					<div className={css(styles.sectionTitle)}>{this.strings.Log_In}</div>
				</div>
				<Container>
					<Row>
						<Column>
							<div className={css(styles.loginMessage)}>
								{this.state.course.registerRequired
									? ""
									: this.strings.loginMessage}
							</div>
						</Column>
					</Row>
					<Row>
						<Column large={6} medium={6} small={12}>
							<div>
								<div>
									<label
										htmlFor="email"
										className={css([loginStyles.label, styles.formLabel])}
									>
										{this.strings.EmailAddress}
									</label>
									<input
										className={css([
											styles.input,
											this.state.error ? loginStyles.inputError : "",
										])}
										id="email"
										type="text"
										value={this.state.loginEmail}
										onChange={e => this._setLoginEmail(e.target.value)}
									/>
								</div>
								<div>
									<div className={css(loginStyles.errorMessage)}>
										{this.state.error}
									</div>
									<button
										className={css([styles.mainButton, styles.loginButton])}
										onClick={this._login}
									>
										{this.strings.LOG_IN}
									</button>
								</div>
								<div className={css(styles.courseLink)}>
									{`${this.strings.dontHaveAnAccount} `}
									<Link
										className={css(styles.clickHere)}
										to={{
											pathname: "/signup",
											query: {
												language: this.props.language,
												redirectpath: `/class/${this.props.params.class_id
													}`,
											},
										}}
									>
										{this.strings.signUp}
									</Link>
								</div>
								{this.state.course.captivate &&
									!this.state.course.registerRequired ? (
									<div className={css(styles.courseLink)}>
										{this.strings.completeAnonymously}
										<a
											href={anonymousLink}
											className={css(styles.clickHere)}
											title={this.strings.completeAnonymously2}
										>
											{this.strings.clickHere}
										</a>
									</div>
								) : null}
								{this.state.course.readerHTML ? (
									<div className={css(styles.courseLink)}>
										{this.strings.viewAccessibilityVersion}
										<a href={accessibleLink} className={css(styles.clickHere)}>
											{this.strings.clickHere}
										</a>
									</div>
								) : null}
							</div>
						</Column>
					</Row>
				</Container>
			</div>
		);
	};

	_selectSession = session => {
		this.setState({ showModal: true, selectedSession: session });
	};

	_dismissModal = () => {
		this.setState({ showModal: false });
	};

	_renderCaptivateContent = () => {
		if (!this.props.loggedIn) {
			return this._loggedOutContent();
		}

		const qs = querystring.stringify({
			email: this.state.email,
			language: this.props.language,
		});

		const accessibleLink = `/class/${this.props.params.class_id}/accessible?${qs}`;

		return (
			<Container>
				<Row>
					<Column
						large={7}
						largeOffset={5}
						medium={7}
						mediumOffset={5}
						small={12}
						smallFullScreen={true}
					>
						<div className={css(styles.startButtonContainer)}>
							<button
								className={css([styles.mainButton, styles.startButton])}
								disabled={!this.state.meRequestReturned}
								onClick={this._startClass}
							>
								{this.strings.START}
							</button>
							{this.state.course.readerHTML ? (
								<div className={css(styles.accessibilityLinkContainer)}>
									{this.strings.viewAccessibilityVersion}
									<a
										href={accessibleLink}
										className={css(styles.clickHere)}
										title={this.strings.viewAccessibilityVersion2}
									>
										{this.strings.clickHere}
									</a>
								</div>
							) : null}
						</div>
					</Column>
				</Row>
			</Container>
		);
	};

	_renderLiveCourse = () => {
		return (
			<div className={css(styles.sectionContentContainer)}>
				{this.state.course.liveClassHosts ? (
					<div>
						<div className={css(styles.sectionTitleBanner)}>
							<div className={css(styles.sectionTitle)}>{this.strings.hostedBy}</div>
						</div>
						<Container>
							<div className={css(styles.hostRow)}>
								{this.state.course.liveClassHosts.map(h => (
									<div key={h.email} className={css(styles.host)}>
										<div
											className={css(styles.avatar)}
											style={
												h.avatarLink
													? { backgroundImage: `url(${h.avatarLink})` }
													: null
											}
										>
											{h.avatarLink ? null : (
												<h1 className={css(styles.avatarText)}>
													{`${h.firstName[0]}${h.lastName[0]}`}
												</h1>
											)}
										</div>
										<h3 className={css(styles.hostText)}>
											{`${h.firstName} ${h.lastName}`}
										</h3>
									</div>
								))}
							</div>
						</Container>
					</div>
				) : null}
				<div className={css(styles.sectionTitleBanner)}>
					<div className={css(styles.sectionTitle)}>
						{this.strings.Dates_Time_Offered}
					</div>
				</div>
				<Container>
					<Row>
						<Column large={9} medium={9}>
							<table className={css(styles.scheduleContainer)}>
								<tbody>
									{this.state.course.classSchedule.map(session => (
										<LiveSession
											key={session.id}
											classId={this.props.params.class_id}
											buttonName={this.strings.ENROLL}
											registrationClosed={this.strings.classFull}
											session={session}
											email={this.state.email}
											language={this.props.language}
											onSessionSelect={this._selectSession}
										/>
									))}
								</tbody>
							</table>

							{this.state.classFullCount > 0 ? (
								<div className={css(styles.disclaimer)}>
									<span>
										{this.strings.registrationDisclaimer1}
										<a href={`/catalog?language=${this.props.language}`}>
											{this.strings.registrationDisclaimer2}
										</a>
										{this.strings.registrationDisclaimer3}
									</span>
								</div>
							) : null}
						</Column>
					</Row>
				</Container>
			</div>
		);
	};

	_renderRecordedCourse = () => {
		return (
			<Container>
				<Row>
					<Column
						large={7}
						largeOffset={5}
						medium={7}
						mediumOffset={5}
						small={12}
						smallFullScreen={true}
					>
						<div className={css(styles.startButtonContainer)}>
							<button
								className={css([styles.mainButton, styles.startButton])}
								disabled={!this.state.meRequestReturned}
								onClick={this._startRecordedClass}
							>
								{this.strings.START_asterisk}
							</button>
						</div>
						<div className={css(styles.disclaimer)}>{this.strings.classDisclaimer}</div>
					</Column>
				</Row>
			</Container>
		);
	};

	_renderAltClasses = () => {
		return (
			<div>
				<div className={css(styles.sectionTitleBanner)}>
					<div className={css(styles.sectionTitle)}>{this.strings.youMayAlsoLike}</div>
				</div>
				<Container>
					<Row className={css(styles.altClassContainer)}>
						{this.state.course.alternativeClasses.map(course => (
							<Column
								large={4}
								medium={4}
								small={12}
								key={`${course.certificate ? course.certificate : course.id}`}
							>
								<AltCourseTile course={course} language={this.props.language} />
							</Column>
						))}
					</Row>
				</Container>
			</div>
		);
	};

	render() {
		const bgTypeStyle = StyleSheet.create({
			typeBg: {
				backgroundColor: typeColors[this.state.course.type],
				height: "18px",
				width: "18px",
				display: "inline-block",
				verticalAlign: "text-bottom",
			},
		});

		return (
			<Page
				activeTab={this.strings.tabNames.CATALOG}
				currentRoute={this.props.pathname}
				language={this.props.language}
				loggedIn={this.props.loggedIn}
			>
				{Object.keys(this.state.course).length > 0 ? (
					<div>
						<Container>
							<div className={css(styles.breadcrumbs)}>
								<div className={css(styles.breadcrumbsCategory)}>
									{this.strings.Catalog}
								</div>
								<div className={css(styles.breadcrumbsTitle)}>
									&nbsp;{`/ ${this.state.course.name}`}
								</div>
							</div>
							<Banner
								images={this.state.course.image}
								title={this.state.course.name}
							/>
							<Row className={css(styles.contentContainer)}>
								<Column large={5} medium={5} small={12}>
									<div>
										<div className={css(styles.description)}>
											{this.state.course.description}
										</div>
									</div>
									<div className={css(styles.typeContainer)}>
										<div className={css(bgTypeStyle.typeBg)} />
										<div className={css(styles.typeTitle)}>
											{this.strings.type[
												this.state.course.type
											].toUpperCase()}
										</div>
										<div className={css(styles.typeDescriptionContainer)}>
											{this.strings.typeDescription[this.state.course.type]}
										</div>
									</div>
								</Column>
								<Column large={7} medium={7} small={12} smallFullScreen={true}>
									<div>
										<ClassDetails
											items={this._learningOutcomes()}
											header={this.strings.whatYoullLearn}
										/>
									</div>
								</Column>
							</Row>
						</Container>
						{this.state.course.type === courseTypes.live ? (
							this._renderLiveCourse()
						) : (
							<div />
						)}

						{this.state.course.type === courseTypes.recorded ? (
							this._renderRecordedCourse()
						) : (
							<div />
						)}

						{this.state.course.type === courseTypes.interactive ||
							this.state.course.type === courseTypes.video ? (
							this._renderCaptivateContent()
						) : (
							<div />
						)}
						{this.state.course.alternativeClasses &&
							this.state.course.alternativeClasses.length > 0 ? (
							this._renderAltClasses()
						) : (
							<div />
						)}
						<LiveRegistrationModal
							showing={this.state.showModal}
							dismiss={this._dismissModal}
							language={this.props.language}
							className={this.state.course.name ? this.state.course.name : ""}
							selectedSession={this.state.selectedSession}
						/>
					</div>
				) : (
					<div />
				)}
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/ClassPage.js